import React, { useEffect, useState } from "react";
import "./InvoicesAndBills.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import { useDispatch, useSelector } from "react-redux";
import { getInvoiceList } from "redux/MedicalAlertUsers/actions";
import { useHistory, useLocation } from "react-router-dom";
import { getRegionList } from "redux/Common/action";
import { formatDate } from "utility";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import MessageSnackBar from "components/widgets/message-snackbar/MessageSnackBar";

const InvoicesAndBills = () => {
  const [invoiceDownloading, setInvoiceDownloading] = useState(false);
  const [inoviceLocalList, setInvoiceList] = useState([]);
  const [counter, setCounter] = useState(0);
  const [snackbarState, setSnackbarState] = useState({ show: false, message: "", type: "error", autoHideDuration: 3000 });
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const { invoiceList, loading, selectedMedicalUser } = useSelector(
    (store) => store?.medicalAlertUsers
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    getInvoiceList({
      dispatch,
      history,
      medical_alert_user_id: selectedMedicalUser?.medical_alert_user_id,
    });
  }, []);

  useEffect(() => {
    if (invoiceList) {
      try {
        let list = JSON.parse(JSON.stringify(invoiceList));
        list?.sort(compare);
        setInvoiceList(list);
      } catch (e) { }
    }
  }, [invoiceList]);

  function compare(a, b) {
    if (a?.is_paid < b?.is_paid) {
      return -1;
    }
    if (a?.is_paid > b?.is_paid) {
      return 1;
    }
    return 0;
  }

  const onPayClick = (item) => {
    const selectedInvoiceList = inoviceLocalList?.filter(
      (item) => item?.isSelected === true && !item?.is_paid
    );

    getRegionList({
      dispatch,
      userType: "accountowner",
    });
    history?.push(ROUTES_CONSTANTS.billingDetails, {
      isFromPayment: true,
      invoices: selectedInvoiceList,
      invoiceItem: item, // Pass the selected invoice item
      ...location.state,
    });
  };

  const onInvoiceSelect = (selectedOption) => {
    // Clear any previous error message
    setErrorMessage("");

    // Find the invoice by sub_invoice_id
    const selectedInvoice = inoviceLocalList.find(invoice =>
      invoice.sub_invoice_id === selectedOption
    );

    if (!selectedInvoice) return;

    // Check if trying to select a paid invoice
    if (selectedInvoice?.is_paid) {
      setErrorMessage("Invoice is already paid");
      setSnackbarState({ show: true, message: "Invoice is already paid", type: "error", autoHideDuration: 3000 });
      return;
    }

    // Update the list to clear all selections and select only the current one
    const list = inoviceLocalList.map((invoice) => ({
      ...invoice,
      isSelected: invoice.sub_invoice_id === selectedOption
    }));

    setInvoiceList(list);
    setSelectedInvoiceId(selectedOption);
    setSelectedInvoice(selectedInvoice);
    setCounter(counter + 1);
  };

  const downLoadInvoice = (item) => {
    let randomNumber = Math.floor(Math.random() * 100);
    setInvoiceDownloading(true);
    fetch(item?.invoice_doc_url)
      .then((response) => response?.blob())
      .then((blob) => {
        setInvoiceDownloading(false);
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link?.setAttribute(
          "download",
          `${item?.sub_invoice_id + "_" + randomNumber}.pdf`
        ); // Customize the downloaded file name
        document.body.appendChild(link);
        link?.click();
        link?.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        setInvoiceDownloading(false);
        console.error("Error downloading PDF:", error);
      });
  };

  return (
    <MainLayout
      text={titles?.invoices_bills}
      isBackHide={false}
      isNavbar={true}
      white={true}
      isLoading={loading || invoiceDownloading}
    >
      {snackbarState?.show && (
        <div className="iab_snackbar_sticky">
          <MessageSnackBar
            message={snackbarState?.message}
            isVisible={true}
            type={snackbarState?.type}
            autoHideDuration={snackbarState?.autoHideDuration}
            onDismiss={() => setSnackbarState((prev) => ({ ...prev, show: false }))}
          />
        </div>
      )}
      <div className="iab_main_container">
        <div className="iab_invoice_list_container">
          {inoviceLocalList?.length > 0 ? inoviceLocalList?.map((item, index) => {
            return (
              <div key={`invoice-${index}`} className="iab_invoice_card_container">
                {/* Individual radio for each invoice (show for both paid and unpaid) */}
                <div className="iab_invoice_card">
                  <div className="iab_invoice_header">
                    <div className="iab_invoice_title_section">
                      <h3 className="iab_invoice_title">{titles?.invoice}</h3>
                      <p className="iab_invoice_id">
                        {item?.sub_invoice_id}
                      </p>
                    </div>
                    {item?.is_paid ? (
                      <button
                        className="iab_pdf_button"
                        onClick={() => downLoadInvoice(item)}
                      >
                        <span className="iab_pdf_button_text">Download</span>
                      </button>
                    ) : null}
                  </div>

                  <div className="iab_invoice_details">
                    <div className="iab_detail_item">
                      <p className="iab_detail_label">{titles?.date}</p>
                      <p className="iab_detail_value">
                        {formatDate(item?.invoice_date)}
                      </p>
                    </div>
                    <div className="iab_detail_item">
                      <p className="iab_detail_label">{titles?.total_invoice}</p>
                      <p className="iab_detail_value">{`$${item?.invoice_amount}`}</p>
                    </div>
                    <div className="iab_detail_item">
                      <p className="iab_detail_label">{titles?.status}</p>
                      <p
                        className={`iab_detail_value ${item?.is_paid ? "iab_paid_status" : "iab_unpaid_status"
                          }`}
                      >
                        {item?.is_paid ? titles?.paid : titles?.unpaid}
                      </p>
                    </div>
                  </div>
                  {!item?.is_paid ? <div className="iab_invoice_pay">
                    <CustomButton
                      width={"100%"}
                      text={titles?.pay}
                      disabled={item?.is_paid}
                      onClick={() => {
                        onPayClick(item);
                      }}
                    />
                  </div> : null}

                </div>
              </div>
            );
          }) : <p className="alert_empty_message">{'No invoice list found.'}</p>}
        </div>
      </div>
    </MainLayout>
  );
};

export default InvoicesAndBills;
